export enum CardsScheme{
  mastercard = 'Mastercard',
  visa = 'Visa',
  amex = 'American Express' 
};